/**
 * Snooze re-showing the PWA update offer after "Più tardi".
 */

const UPDATE_OFFER_SNOOZE_KEY = 'pwa_update_offer_snooze';

const SNOOZE_DURATION_MS = 6 * 60 * 60 * 1000;

export interface UpdateOfferSnooze {
  until: number;
  /** scriptURL of waiting worker when user dismissed (same SW = keep snoozing). */
  dismissedWaitingScriptUrl: string | null;
  /** PWA_VERSION user dismissed for version-mismatch offer. */
  dismissedForVersion?: string | null;
}

export function readUpdateOfferSnooze(): UpdateOfferSnooze | null {
  try {
    const raw = localStorage.getItem(UPDATE_OFFER_SNOOZE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as UpdateOfferSnooze;
    if (typeof parsed.until !== 'number') return null;
    return parsed;
  } catch {
    return null;
  }
}

export function writeUpdateOfferSnooze(payload: UpdateOfferSnooze): void {
  try {
    localStorage.setItem(UPDATE_OFFER_SNOOZE_KEY, JSON.stringify(payload));
  } catch {
    // ignore
  }
}

export function clearUpdateOfferSnooze(): void {
  try {
    localStorage.removeItem(UPDATE_OFFER_SNOOZE_KEY);
  } catch {
    // ignore
  }
}

export function isServiceWorkerOfferSnoozed(waitingScriptUrl: string | null): boolean {
  if (waitingScriptUrl == null) return false;
  const snooze = readUpdateOfferSnooze();
  if (!snooze || Date.now() >= snooze.until) return false;
  return snooze.dismissedWaitingScriptUrl === waitingScriptUrl;
}

export function isVersionOfferSnoozed(currentAppVersion: string): boolean {
  const snooze = readUpdateOfferSnooze();
  if (!snooze || Date.now() >= snooze.until) return false;
  return snooze.dismissedForVersion === currentAppVersion;
}

export function defaultSnoozeAfterDismissServiceWorker(
  dismissedWaitingScriptUrl: string | null
): void {
  writeUpdateOfferSnooze({
    until: Date.now() + SNOOZE_DURATION_MS,
    dismissedWaitingScriptUrl,
    dismissedForVersion: null,
  });
}

export function defaultSnoozeAfterDismissVersion(dismissedForVersion: string): void {
  writeUpdateOfferSnooze({
    until: Date.now() + SNOOZE_DURATION_MS,
    dismissedWaitingScriptUrl: null,
    dismissedForVersion,
  });
}
